import { isEmpty } from "lodash";
import { Article } from "./Article";
import { Validate } from "./Validate";
import { Warehouse } from "./Warehouse";
import { getDictionary } from "../utilities/utilities";

const dictionary = getDictionary();

export interface WarehouseArticleSettings {
  id: string;
  creationDate: string;
  creationwarehouseArticleSettings: string;
  lastModifiedDate: string;
  lastModifiedwarehouseArticleSettings: string;
  warehouse: Warehouse;
  article: Article;
  warehouseId: string;
  articleId: string;
  lowStockThreshold: number;
  enabled: boolean;
  notificationEmails: string;
}

export interface CreateWarehouseArticleSettings {
  warehouseId: string;
  articleId: string;
  lowStockThreshold: number;
  enabled: boolean;
  notificationEmails: string;
}

export interface UpdateWarehouseArticleSettings {
  id: string;
  warehouseId: string;
  articleId: string;
  lowStockThreshold: number;
  enabled: boolean;
  notificationEmails: string;
}

export const defaultWarehouseArticleSettings: Partial<WarehouseArticleSettings> =
  {
    enabled: true,
  };

// Convert function to create
export const convertWarehouseArticleSettingsToCreate = (
  warehouseArticleSettings: WarehouseArticleSettings,
  parentId: string,
  articleId: string,
): CreateWarehouseArticleSettings => {
  return {
    warehouseId: parentId,
    articleId: articleId,
    lowStockThreshold: warehouseArticleSettings.lowStockThreshold,
    enabled: warehouseArticleSettings.enabled,
    notificationEmails: warehouseArticleSettings.notificationEmails,
  };
};

// Convert function to update
export const convertWarehouseArticleSettingsToUpdate = (
  warehouseArticleSettings: WarehouseArticleSettings,
): UpdateWarehouseArticleSettings => {
  return {
    id: warehouseArticleSettings.id,
    warehouseId: warehouseArticleSettings.warehouseId,
    articleId: warehouseArticleSettings.articleId,
    lowStockThreshold: warehouseArticleSettings.lowStockThreshold,
    enabled: warehouseArticleSettings.enabled,
    notificationEmails: warehouseArticleSettings.notificationEmails,
  };
};

export const validate = (
  warehouseArticleSettings: WarehouseArticleSettings,
): Validate => {
  const validate: Validate = { isValid: true, errors: {} };

  if (!warehouseArticleSettings.lowStockThreshold) {
    validate.errors.lowStockThreshold = dictionary.messages.mandatory_field;
  }

  if (!warehouseArticleSettings.notificationEmails) {
    validate.errors.notificationEmails = dictionary.messages.mandatory_field;
  } else {
    const emailsRaw = warehouseArticleSettings.notificationEmails;

    const allEmailsRegex =
      /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}(\s*,\s*[^\s@]+@[^\s@]+\.[a-zA-Z]{2,})*$/;

    if (!allEmailsRegex.test(emailsRaw)) {
      validate.errors.notificationEmails =
        dictionary.messages.you_can_enter_multiple_emails_separated_by_commas_and_each_email_must_be_in_a_valid_format;
    } else {
      const emails = emailsRaw.split(",").map((e) => e.trim().toLowerCase());
      const hasDuplicates = emails.some(
        (email, index) => emails.indexOf(email) !== index,
      );

      if (hasDuplicates) {
        validate.errors.notificationEmails =
          dictionary.messages.duplicate_emails;
      }
    }
  }

  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }

  return validate;
};
